export default "__VITE_ASSET__Dje9zP_7__"